;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { faro, LogLevel as GrafanaLogLevel } from '@grafana/faro-web-sdk'
import { LogLevel, LogPayload, Transport } from '@qogita/logger/transport'

const logLevelMap: Record<LogLevel, GrafanaLogLevel> = {
  debug: GrafanaLogLevel.DEBUG,
  info: GrafanaLogLevel.INFO,
  warn: GrafanaLogLevel.WARN,
  error: GrafanaLogLevel.ERROR,
}

export function createLogTransport({
  enabled,
  fallback,
}: {
  enabled: boolean
  /**
   * Provide a fallback transport to use before Grafana Faro is initialized
   * This fallback only applies if this transport is enabled
   *
   * For example, log to the console before Grafana Faro is initialized
   * @example consoleTransport
   *
   *  */
  fallback?: Transport
}): Transport | undefined {
  if (!enabled) {
    return undefined
  }

  function log(level: LogLevel, payload: LogPayload) {
    const api = faro.api
    if (!api) {
      return fallback?.[level](payload)
    }

    api.pushLog([JSON.stringify(payload)], {
      level: logLevelMap[level],
      context: buildGrafanaContext(payload),
    })
  }

  return {
    debug: (payload) => log('debug', payload),
    info: (payload) => log('info', payload),
    warn: (payload) => log('warn', payload),
    error: (payload) => log('error', payload),
  }
}

/**
 * Grafana wants context to be simple key value pairs of primitives, so we pick out some values we care about and serialize other nested objects
 */
function buildGrafanaContext(payload: LogPayload) {
  const grafanaContext: Record<string, string> = {}
  // handle properties of the error object
  if (payload.error) {
    const { digest, fingerprint } = payload.error
    if (digest) {
      grafanaContext['error_digest'] = digest
    }
    if (fingerprint) {
      grafanaContext['error_fingerprint'] = fingerprint
    }
  }
  // handle properties of the context object
  if (payload.context) {
    for (const [key, value] of Object.entries(payload.context)) {
      grafanaContext[key] = JSON.stringify(value)
    }
  }
  return grafanaContext
}
